<template>
  <div class="page-content registrationPage">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">综合评价选课报名</span>
    </p>

    <!--  -->
    <div class="content">
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="考次" size="small" class="mb0">
          <el-select v-model="form.examConfigId" placeholder="请选择" @change="changeExamConfig">
            <el-option :label="item.examTimeCode" :value="item.id" v-for="(item, index) in examConfigList"
              :key="index"></el-option>
          </el-select>
          <span class="pay-btn">
            <el-button type="primary" @click="handleRegistration()" v-if="currentExamConfig.isAllowPerson == '1'">报名</el-button>
          </span>
          <span class="enroll-time" v-if="currentExamConfig">
            报名时间：{{ formatDateTime(currentExamConfig.personEnrollStartTime) }} -
            {{ formatDateTime(currentExamConfig.personEnrollEndTime) }}
          </span>
        </el-form-item>
      </el-form>
      <div class="table-container" v-if="list.length > 0">
        <!-- <div class="mb10">
          <el-button type="primary" size="small" @click="checkedGoToPay()"
            :disabled="checkedRows.length === 0">缴费</el-button>
        </div> -->
        <el-table :data="list" border style="width: 100%"
          :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }">
          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" :disabled="scope.row.isPay === '1'"
                @change="handleCheckboxChange"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="课程" min-width="140" align="center">
            <template slot-scope="scope">
              {{ scope.row.courseCode ? scope.row.courseCode + '-' : '' }} {{ scope.row.courseName }}
            </template>
          </el-table-column> -->
          <el-table-column prop="courseCode" label="课程代码" align="center"></el-table-column>
          <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
          <el-table-column prop="score" label="学分" width="120" align="center"></el-table-column>
          <!-- <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isPay == '1'" class="YZF-text">已缴费</span>
              <a v-else href="javascript:void(0)" class="pay-link" @click="handleGoToPay([scope.row.courseId])">去缴费</a>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <Empty v-if="list.length == 0"></Empty>
    </div>

    <registrationDialog ref="registrationDialog" @refresh="getData"></registrationDialog>
    <!-- 支付弹窗 -->
    <PayDialog ref="payDialog" @refresh="getData" />

  </div>
</template>

<script>
import { mapState } from "vuex"
import Empty from "@/components/Empty.vue";
import registrationDialog from "@/components/registrationDialog.vue";
import PayDialog from './registrationPayDialog.vue'

export default {
  components: {
    PayDialog,
    registrationDialog,
    Empty,
  },
  data () {
    return {
      examConfigList: [],
      list: [],
      form: {
        examConfigId: '',
      },
      checkedRows: [],
    };
  },
  computed: {
    ...mapState(['user']),
    currentExamConfig () {
      return this.examConfigList.find(item => item.id === this.form.examConfigId) || null
    }
  },
  async mounted () {
    this.getExamConfig()
  },
  methods: {
    formatDateTime (time) {
      if (!time) return '-'
      return String(time)
    },
    async getExamConfig () {
      this.$http.get('/student/pc/chooseCourse/examConfigSelect', {}).then((res) => {
        this.examConfigList = res;
        if(this.examConfigList.length > 0) {
          this.form.examConfigId = this.examConfigList[0]?.id
          this.getData();
        }
      })
    },
    changeExamConfig () {
      this.getData();
    },
    async getData () {
      this.$http.get('/student/pc/chooseCourse', { ...this.form, size: '99999' }).then((res) => {
        this.list = res.records
      })
    },
    // 报名
    handleRegistration () {
      if (!this.form.examConfigId) {
        this.$message.error('请选择考次')
        return
      }
      this.$refs.registrationDialog.open(this.form.examConfigId)
    },
    handleCheckboxChange () {
      // 复选框变化时的处理
      const checkedRows = this.list.filter((item) => item.checked);
      this.checkedRows = checkedRows
    },
    // 缴费
    checkedGoToPay () {
      if (this.checkedRows.length === 0) {
        this.$message.error('请选择要缴费的课程')
        return
      }
      this.handleGoToPay(this.checkedRows.map((item) => item.courseId))
    },
    // 单条 / 多选 缴费统一入口
    handleGoToPay (ids) {
      this.$http.post('/student/pc/chooseCourse/createOrder', ids).then((res) => {
        if (res) {
          this.$refs.payDialog.open(res)
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.registrationPage {
  .content {
    box-sizing: border-box;
    padding: 10px 50px;
    min-height: 450px;

    .table-container {
      padding-top: 20px 0;
    }
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.pay-btn {
  margin-left: 20px;
}

.enroll-time {
  margin-left: 12px;
  color: #666;
  font-size: 13px;
}

.mb10 {
  margin-bottom: 10px;
}

.YZF-text {
  color: #1a1a1a;
  font-size: 14px;
}

.pay-link {
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
</style>
